<template>
  <div class="order-list">
    <el-card class="query-card">
      <el-form :model="queryParams" ref="queryForm" label-width="110px" size="small" inline>



        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="开始时间" prop="startTime">
            <el-date-picker
              v-model="queryParams.startTime"
              type="datetime"
              placeholder="选择开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              class="full-width"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="结束时间" prop="endTime">
            <el-date-picker
              v-model="queryParams.endTime"
              type="datetime"
              placeholder="选择结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              class="full-width"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="流水订单号" prop="orderNo">
            <div class="input-with-more">
              <el-input v-model="queryParams.orderNo" placeholder="请输入订单号" clearable />
              <el-button type="text" @click="openMoreDialog('orderNo')">More</el-button>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="商户订单号" prop="trMerOrderno">
            <div class="input-with-more">
              <el-input v-model="queryParams.trMerOrderno" placeholder="请输入商户订单号" clearable />
              <el-button type="text" @click="openMoreDialog('trMerOrderno')">More</el-button>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="地址" prop="address">
            <div class="input-with-more">
              <el-input v-model="queryParams.address" placeholder="请输入地址" clearable />
              <el-button type="text" @click="openMoreDialog('address')">More</el-button>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="电话" prop="ciTel">
            <div class="input-with-more">
              <el-input v-model="queryParams.ciTel" placeholder="请输入电话" clearable />
              <el-button type="text" @click="openMoreDialog('ciTel')">More</el-button>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="商户号" prop="merNo">
            <div class="input-with-more">
              <el-input v-model="queryParams.merNo" placeholder="请输入商户号" clearable />
              <el-button type="text" @click="openMoreDialog('merNo')">More</el-button>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="商户号别名" prop="merNo1">
            <div class="input-with-more">
              <el-input v-model="queryParams.merNo1" placeholder="请输入商户号别名" clearable />
              <el-button type="text" @click="openMoreDialog('merNo1')">More</el-button>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="IP地址" prop="ipAddress">
            <div class="input-with-more">
              <el-input v-model="queryParams.ipAddress" placeholder="请输入ip地址" clearable />
              <el-button type="text" @click="openMoreDialog('ipAddress')">More</el-button>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="邮箱" prop="ciEmail">
            <div class="input-with-more">
              <el-input v-model="queryParams.ciEmail" placeholder="请输入邮箱" clearable />
              <el-button type="text" @click="openMoreDialog('ciEmail')">More</el-button>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="姓名" prop="fullName">
            <div class="input-with-more">
              <el-input v-model="queryParams.fullName" placeholder="请输入姓名" clearable />
              <el-button type="text" @click="openMoreDialog('fullName')">More</el-button>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="卡号" prop="cardnopart">
            <div class="input-with-more">
              <el-input v-model="queryParams.cardnopart" placeholder="请输入卡号" clearable />
              <el-button type="text" @click="openMoreDialog('cardnopart')">More</el-button>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="名" prop="firstname">
            <div class="input-with-more">
              <el-input v-model="queryParams.firstname" placeholder="请输入名" clearable />
              <el-button type="text" @click="openMoreDialog('firstname')">More</el-button>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="姓" prop="lastname">
            <div class="input-with-more">
              <el-input v-model="queryParams.lastname" placeholder="请输入姓" clearable />
              <el-button type="text" @click="openMoreDialog('lastname')">More</el-button>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="卡种" prop="ciCardtype">
            <el-select v-model="queryParams.ciCardtype" placeholder="请选择状态" clearable class="full-width">
              <el-option label="Visa" value="1"></el-option>
              <el-option label="Master" value="2"></el-option>
              <el-option label="JCB" value="3"></el-option>
              <el-option label="AE" value="4"></el-option>
              <el-option label="DC" value="5"></el-option>
              <el-option label="DISCOVER" value="6"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="cardSha" prop="cardSha">
            <div class="input-with-more">
              <el-input v-model="queryParams.cardSha" placeholder="请输入cardSha" clearable />
              <el-button type="text" @click="openMoreDialog('cardSha')">More</el-button>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item label="通道代码" prop="trChaCode">
            <div class="input-with-more">
              <el-input v-model="queryParams.trChaCode" placeholder="请输入通道代码" clearable />
              <el-button type="text" @click="openMoreDialog('trChaCode')">More</el-button>
            </div>
          </el-form-item>
        </el-col>



<!--        <el-col :span="24">
          <el-form-item style="text-align: center; margin-top: 10px; margin-bottom: 0;" label-width="0">
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
            <form
              action="/api/es/exportUnnormal"
              method="POST"
              target="_blank"
              @submit="onDownloadSubmit"
              style="display: inline-block; margin-left: 10px;"
            >
              <input type="hidden" name="params" :value="JSON.stringify(queryParams)">
              <el-button native-type="submit" :disabled="!hasSearched" type="success">
                <i class="el-icon-download"></i>
                下载
              </el-button>
            </form>
          </el-form-item>
        </el-col>-->
        <el-col :span="24">
          <el-form-item style="display: flex; justify-content: center; margin-top: 20px; margin-bottom: 20px;" label-width="0">
            <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
            <el-button @click="handleReset">{{ $t('reset') }}</el-button>
          </el-form-item>
        </el-col>

        <!-- 通用 More 弹窗（只保留一个）  :title="getDialogTitle" -->
        <el-dialog
          :visible.sync="moreDialogVisible"
          width="800px"
          @close="onMoreDialogClose"
        >
          <el-input
            type="textarea"
            :rows="8"
            v-model="moreInput"
            :placeholder="`请输入多个值,请使用英文逗号隔开，做到输入1000个值。例如：\nVALUE1\nVALUE2, VALUE3`"
          />
          <span slot="footer">
    <el-button @click="closeMoreDialog">取消</el-button>
    <el-button type="primary" @click="confirmMoreInput">确定</el-button>
  </span>
        </el-dialog>
      </el-form>
    </el-card>

    <div class="action-toolbar">

      <el-button  :disabled="!hasSearched" >下载 </el-button>
      <el-button  :disabled="!hasSearched" >查看详情 </el-button>

      <!-- 预留权限控制位示例： -->
      <!-- <el-button v-if="checkPermission('order:delete')" type="danger" size="small" icon="el-icon-delete">删除</el-button> -->
    </div>

    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" border style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >
        <el-table-column prop="utr_no" label="流水订单号" width="210"></el-table-column>
        <el-table-column prop="utr_mer_orderno" label="商户订单号" width="210"></el-table-column>
        <el-table-column prop="utr_mer_no" label="商户名"></el-table-column>
        <el-table-column prop="mer_no1" label="商户别名"></el-table-column>
        <el-table-column prop="utr_gw_no" label="网关接入号"></el-table-column>
        <el-table-column prop="utr_bank_code" label="支付银行" width="110"></el-table-column>
        <el-table-column prop="utr_cha_code" label="支付通道代码"></el-table-column>
        <el-table-column prop="cha_name" label="支付通道名称"></el-table-column>
<!--        <el-table-column prop="tr_bankcurrency" label="收单币种"></el-table-column>-->
<!--        <el-table-column prop="tr_bankamout" label="收单金额"></el-table-column>-->
        <el-table-column label="交易金额" width="100">
          <template #default="scope">
            <span>{{ scope.row.utr_currency }} {{ scope.row.utr_amount }}</span>
          </template>
        </el-table-column>


        <el-table-column prop="utr_riskinfo" label="未通过分控信息"></el-table-column>
        <el-table-column prop="utr_passriskinfo" label="通过风控信息"></el-table-column>

<!--        <el-table-column prop="TR_CURRENCY" label="交易币种"></el-table-column>
        <el-table-column prop="tr_amount" label="交易金额"></el-table-column>-->
        <el-table-column label="交易金额" width="100">
          <template #default="scope">
            <span>{{ scope.row.tr_currency }} {{ scope.row.tr_amount }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="utr_payendtime" label="交易时间" width="180">
          <template #default="scope">
            <span>{{ formatTime(scope.row.utr_payendtime) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="ci_cardnopart" label="卡号"></el-table-column>
        <el-table-column prop="ci_country" label="卡所属国"></el-table-column>
        <el-table-column prop="ci_issuingbank" label="发卡行"></el-table-column>

<!--        <el-table-column prop="full_name" label="姓名"></el-table-column>-->
        <el-table-column prop="full_name" label="姓名">
          <template slot-scope="{ row }">
            <span style="white-space: pre-wrap;">{{ row.full_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ci_email" label="邮箱"></el-table-column>
        <el-table-column prop="ci_tel" label="联系电话"></el-table-column>
        <el-table-column prop="ci_address" label="地址"></el-table-column>
        <el-table-column prop="ci_ipaddress" label="ip地址"></el-table-column>

      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 16px; text-align: right;"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: "OrderList",
  data() {
    return {
      loading: false,
      queryParams: {
        orderNo: "",
        bankOrderNo: "",
        trMerOrderno: "",
        status: "",
        merNo: "",
        merNo1: "",
        address:"",
        ciTel:"",
        startTime: "",
        endTime: "",
        ipAddress: "",
        ciEmail: "",
        fullName: "",
        firstname: "",
        lastname: "",
        ciCardtype: "",
        cardSha: "",
        trChaCode: "",
        cardnopart: "",
        ciCountry: "",
        cilsuingBank: "",
        experianCardIssuer: "",
      },
      moreDialogVisible: false,
      moreInput: '',          // 弹窗中的文本内容
      currentField: null,     // 当前正在编辑的字段名，如 'orderNo'
      hasSearched: false,   //  是否有进行查询

      tableData: [],
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      statusMap: {
        "-2": "warning",    // 待确认 - 黄色
        "-1": "info",       // 待处理 - 蓝色
        "0": "danger",      // 失败 - 红色
        "1": "success",     // 成功 - 绿色
      },
      statusText: {
        "-2": "待确认",
        "-1": "待处理",
        "0": "失败",
        "1": "成功",
      },
    };
  },
  created() {
   // this.handleSearch(); // 初始化加载数据
    // 组件创建后设置默认时间
    this.setDefaultTime(); //时间设置
  },
  methods: {
    //时间格式
    formatTime(isoTime) {
      if (!isoTime) return '-';

      try {
        const date = new Date(isoTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        return isoTime; // 如果解析失败，返回原值
      }},

    setDefaultTime() {
      // 只有在当前时间为空时才设置默认值
      if (!this.queryParams.startTime) {
        this.queryParams.startTime = this.getDefaultStartTime();
      }
      if (!this.queryParams.endTime) {
        this.queryParams.endTime = this.getCurrentTime();
      }
    },
    // 获取当前时间字符串，格式：YYYY-MM-DD HH:mm:ss
    getCurrentTime() {
     // return this.formatDateTime(new Date());
      const now = new Date();
      // 设置为当天 23:59:59
      now.setHours(23, 59, 59, 999); // 时, 分, 秒, 毫秒
      return this.formatDateTime(now);
    },
    // 获取当前时间往前推 1 年
    getDefaultStartTime() {
  /*    const now = new Date();
      const oneYearAgo = new Date(now);
      oneYearAgo.setFullYear(now.getFullYear() - 1);
      return this.formatDateTime(oneYearAgo);*/
      const now = new Date();

      // 1. 获取当前时间的毫秒时间戳
      const currentTimestamp = now.getTime();

      // 2. 计算2天的毫秒数 (2 * 24小时 * 60分钟 * 60秒 * 1000毫秒)
      const twoDaysInMs = 2 * 24 * 60 * 60 * 1000;

      // 3. 用当前时间戳减去2天的毫秒数
      const twoDaysAgoTimestamp = currentTimestamp - twoDaysInMs;

      // 4. 基于新的时间戳创建日期对象
      const twoDaysAgo = new Date(twoDaysAgoTimestamp);

      // 5. 重置为当天 00:00:00 (注意：这里重置的是"2天前"那天的0点)
      twoDaysAgo.setHours(0, 0, 0, 0);

      return this.formatDateTime(twoDaysAgo);
    },
    // 格式化日期为 'YYYY-MM-DD HH:mm:ss'
    formatDateTime(date) {
      const pad = (num) => String(num).padStart(2, '0');
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },
    // 过滤数据（模拟后端查询）
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          orderNo: this.queryParams.orderNo || undefined,
          bankOrderNo: this.queryParams.bankOrderNo || undefined,
          trMerOrderno: this.queryParams.trMerOrderno || undefined,
          status: this.queryParams.status || undefined,
          merNo: this.queryParams.merNo || undefined,
          merNo1: this.queryParams.merNo1 || undefined,
          address: this.queryParams.address || undefined,
          ciTel: this.queryParams.ciTel || undefined,
          ipAddress: this.queryParams.ipAddress || undefined,
          ciEmail: this.queryParams.ciEmail || undefined,
          fullName: this.queryParams.fullName || undefined,
          firstname: this.queryParams.firstname || undefined,
          lastname: this.queryParams.lastname || undefined,
          ciCardtype: this.queryParams.ciCardtype || undefined,
          cardSha: this.queryParams.cardSha || undefined,
          trChaCode: this.queryParams.trChaCode || undefined,
          cardnopart: this.queryParams.cardnopart || undefined,
          ciCountry: this.queryParams.ciCountry || undefined,
          cilsuingBank: this.queryParams.cilsuingBank || undefined,
          experianCardIssuer: this.queryParams.experianCardIssuer || undefined,


          startTime: this.queryParams.startTime || undefined,
          endTime: this.queryParams.endTime || undefined,
          page: this.pagination.page,
          size: this.pagination.size,
        };

        const res = await this.$axios.post('/api/es/unnormal',  params );

        if (res.data.code === '200') {
          this.tableData = res.data.data.list || [];
          this.pagination.total = res.data.data.total || 0;
          if(this.pagination.total > 0){
            this.hasSearched = true;
          }
        } else {
          this.$message.error(res.data.message || '查询失败');
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        if (err.response){
          console.log("测试登录过期 - 完整错误对象:", err.response);
          console.log("测试登录过期 - 状态码:", err.response.status);
          console.log("测试登录过期 - 响应数据:", err.response.data);
          console.log("测试登录过期 - 响应数据(JSON):", JSON.stringify(err.response.data, null, 2));

          if(err.response.status === 401){
            const message = err.response.data.message || '登录已经过期';
            console.log("登录失效消息:", message);
            this.$message.error(message);

            // 清除本地 token 并跳转到登录页
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("user");
            this.$router.push('/login');
          }
        }
        console.error('查询订单失败:', err);
        this.$message.error('网络错误，请稍后重试');
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 分页：每页条数变化
    handleSizeChange(val) {
    /*  this.pagination.size = val;
      this.filterData();*/
      this.pagination.size = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
     /* this.pagination.page = val;
      this.filterData();*/

      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 下载
   /* async downloadCsv() {
      if (!this.hasSearched) {
        this.$message.warning('请先点击【查询】按钮，再进行下载');
        return;
      }
      try {
        const response = await this.$axios.post(
          '/api/export/trades1',
          this.queryParams, // 直接传当前查询条件（JSON）
          {
            responseType: 'blob', // 接收二进制文件流
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        let filename = 'trades.csv'; // 默认
        const disposition = response.headers['content-disposition'];

        if (disposition) {
          // 优先尝试解析 filename*=UTF-8''...
          const utf8FilenameMatch = disposition.match(/filename\*=UTF-8''(.+?)(;|$)/i);
          if (utf8FilenameMatch && utf8FilenameMatch[1]) {
            // decodeURIComponent 会自动处理 %xx 编码
            filename = decodeURIComponent(utf8FilenameMatch[1]);
          } else {
            // 回退到 filename=...（可能无引号或带引号）
            const asciiMatch = disposition.match(/filename=("?)(.+?)\1(;|$)/i);
            if (asciiMatch && asciiMatch[2]) {
              filename = asciiMatch[2];
            }
          }
        }

        // 触发下载
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = filename; // ✅ 直接赋值 download 属性
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('CSV 下载失败:', error);
        this.$message.error('下载失败，请稍后重试');
      }
    },*/
    // 下载表单提交处理
    onDownloadSubmit() {
      if (!this.hasSearched) {
        this.$message.warning('请先点击【查询】按钮，再进行下载');
        return false; // 阻止表单提交
      }

      this.$message.success('开始生成文件，请查看浏览器下载列表...');

      return true; // 允许表单提交
    },

    // 通用打开弹窗方法
    openMoreDialog(fieldName) {
      this.currentField = fieldName;
      const currentValue = this.queryParams[fieldName] || '';
      // 直接显示原始内容（可能含逗号、空格等）
      this.moreInput = currentValue;
      this.moreDialogVisible = true;
    },

   /* confirmMoreInput() {
      this.queryParams[this.currentField] = this.moreInput; // ✅ 完全原样保存
      this.closeMoreDialog();
    },*/
    confirmMoreInput() {
      // 只需要去掉 # 前后的空格，保留值内部的其他空格
      const cleanedValue = this.moreInput
        .split('#')
        .map(item => item.trim())  // 去掉每个值的前后空格
        .filter(item => item.length > 0)  // 过滤空值
        .join('#');  // 用 # 重新连接

      this.queryParams[this.currentField] = cleanedValue;
      this.closeMoreDialog();

      this.$message.success(`已设置 ${cleanedValue.split('#').length} 个值`);
    },

    closeMoreDialog() {
      this.moreDialogVisible = false;
      this.currentField = null;
      this.moreInput = '';
    },

    onMoreDialogClose() {
      this.closeMoreDialog();
    },

  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}
/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}
.table-card ::v-deep .el-table {
  min-width: 100%;
}
/* 防止标签文字在空间被压缩时换行，保持表单高度一致 */
.query-card ::v-deep .el-form-item__label {
  white-space: nowrap;
}

/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/order/ListUnnPage.vue